import { render, staticRenderFns } from "./OtherRegulationsInput.vue?vue&type=template&id=e260f8fe&"
import script from "./OtherRegulationsInput.vue?vue&type=script&lang=js&"
export * from "./OtherRegulationsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/form/OtherRegulationsInput.vue
// module id = null
// module chunks = 